<template>
  <b-card no-body class="mb-1 border-0 p-0">
    <!-- Siderbar for Filters Advance -->
    <sidebar-filters
      :filter="filter"
      @reload="sideBarSearch"
      @resetAllFilters="resetFiltersButtons"
    ></sidebar-filters>

    <div class="mx-1 mt-1" v-if="showPagination">
      <b-row>
        <!-- Info Paginator -->
        <b-col
          sm="12"
          md="6"
          class="d-flex align-items-center justify-content-center justify-content-md-start"
        >
          <span
            class="text-muted"
            v-t="{
              path: 'ShowingAll',
              locate: $i18n.locale,
              args: { from: paginate.from, to: paginate.to, of: paginate.of },
            }"
          >
          </span>
        </b-col>

        <!-- Pagination -->
        <b-col
          sm="12"
          md="6"
          class="d-flex align-items-center justify-content-center justify-content-md-end"
        >
          <slot name="pagination">
            <b-pagination
              v-model="paginate.currentPage"
              :total-rows="paginate.of"
              :per-page="paginate.perPage"
              first-number
              last-number
              class="mt-1 mt-md-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="$emit('onChangeCurrentPage', $event)"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </slot>
        </b-col>
      </b-row>
    </div>

    <div class="mx-1">
      <b-row>
        <b-col
          v-if="showPagination"
          sm="12"
          md="6"
          :lg="noVisiblePrincipalFilter ? '6' : '3'"
          class="d-flex align-items-center justify-content-center justify-content-md-start mb-1 mb-md-0"
        >
          <label v-t="'SHOW'"></label>
          <v-select
            v-model="paginate.perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="paginate.perPageOptions"
            :clearable="false"
            style="min-width: 100px"
            size="sm"
            class="per-page-selector d-inline-block mx-50"
            @input="$emit('reload', false)"
          />
          <label class="mr-2" v-t="'ENTRIES'"></label>
          <feather-icon
            class="cursor-pointer"
            icon="RefreshCcwIcon"
            size="20"
            @click="resetFilter"
          />

          <slot name="special-button"> </slot>
        </b-col>

        <b-col
          :sm="buttonsColConfig.sm"
          :md="buttonsColConfig.md"
          :lg="buttonsColConfig.lg"
        >
          <div :class="buttonsWrapperClass">
            <slot name="buttons" />
          </div>
        </b-col>

        <!-- Search -->
        <b-col md="12" :lg="!showPagination ? '12' : '4'" class="px-0">
          <!-- :offset-lg="!showPagination ? '8' : '0'" -->

          <div
            class="d-flex align-items-center justify-content-end align-items-center mt-1 mt-lg-0"
          >
            <slot name="buttons-filter" />
            <b-input-group
              v-if="!noVisiblePrincipalFilter"
              :class="showAdvancedFilters ? 'mr-1' : ''"
            >
              <b-form-input
                v-if="filterPrincipal.type === 'input'"
                v-model="filterPrincipal.model"
                :type="filterPrincipal.inputType"
                :placeholder="$t(filterPrincipal.placeholder)"
                :class="filterPrincipal.class"
                @keyup.enter="$emit('reload')"
              />
              <b-input-group-append>
                <b-button variant="primary" @click="$emit('reload')">
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-button
              v-if="hasFilters && showAdvancedFilters"
              v-b-toggle.sidebar-right
              v-b-tooltip.hover.right="$t('advanced search')"
              variant="primary"
            >
              <div class="d-flex justify-content-between">
                <feather-icon icon="FilterIcon" size="15" />
              </div>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="table-responsive mt-1">
      <slot name="table" />
    </div>

    <div class="mx-1 mt-0 mb-0" v-if="showPagination">
      <b-row>
        <b-col
          md="6"
          class="d-flex align-items-center justify-content-center justify-content-md-start"
        >
          <span
            class="text-muted"
            v-t="{
              path: 'ShowingAll',
              locate: $i18n.locale,
              args: { from: paginate.from, to: paginate.to, of: paginate.of },
            }"
          ></span>
        </b-col>
        <!-- Pagination -->
        <slot name="footer" />
        <b-col
          md="6"
          class="d-flex align-items-center justify-content-center justify-content-md-end mb-0"
        >
          <slot name="pagination">
            <!-- :total-rows=dataMeta.of -->
            <b-pagination
              v-model="paginate.currentPage"
              :total-rows="paginate.of"
              :per-page="paginate.perPage"
              first-number
              last-number
              class="mt-1 mt-md-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="$emit('onChangeCurrentPage', $event)"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </slot>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import vSelect from "vue-select";
import SidebarFilters from "@/views/commons/filter-slot/SidebarFilters.vue";
import Ripple from "vue-ripple-directive";
import { VBToggle } from "bootstrap-vue";
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    paginate: {
      type: Object,
      required: true,
    },
    noVisiblePrincipalFilter: {
      required: false,
      default: false,
    },
    filterPrincipal: {
      required: false,
      type: Object,
    },
    filter: { required: false, type: Array, default: [] },

    showPagination: {
      required: false,
      default: true,
    },
    showAdvancedFilters: {
      required: false,
      default: true,
    },
    buttonsColConfig: {
      type: Object,
      default: () => ({
        sm: 12,
        md: 6,
        lg: 5,
      }),
    },
    buttonsWrapperClass: {
      type: String,
      default:
        "d-flex align-items-center justify-content-center justify-content-md-end",
    },
  },
  components: {
    vSelect,
    SidebarFilters,
  },
  directives: {
    "b-toggle": VBToggle,
    Ripple,
  },
  computed: {
    hasFilters() {
      return this.filter ? Object.keys(this.filter).length !== 0 : false;
    },
    ...mapGetters({
      perPage: "appConfig/perPage",
    }),
  },
  mounted() {
    this.paginate.perPage = parseInt(this.perPage);
    if (this.paginate.perPageOptions == null) {
      this.paginate.perPageOptions = [10, 25, 50, 100];
    }
  },
  methods: {
    sideBarSearch() {
      this.filterPrincipal.model = "";
      this.$emit("reload");
    },
    resetFiltersButtons() {
      if (this.filter) {
        this.filter.map((fil) => {
          fil.model = null;
        });
      }
      this.$emit("reset-all-filters");
    },
    resetFilter() {
      if (this.filter) {
        this.filter.map((fil) => {
          fil.model = null;
        });
      }
      this.filterPrincipal.model = "";
      this.$emit("reload");
    },
  },
  created() {
    if (this.filter) {
      this.filter.map((fil) => {
        fil.model = null;
      });
    }
    this.filterPrincipal.model = "";
  },
  data() {
    return {
      basicSearch: "",
    };
  },
};
</script>